module.exports = __webpack_public_path__ + "static/media/compass.0a04e8f3.svg";